import React from "react";

interface CharCounterProps {
  value: string;
  limit: number;
  label?: string;
}

/**
 * Soft character-count nudge. Shows the current count against an
 * admin-configurable limit and warns (never blocks) when exceeded.
 */
const CharCounter: React.FC<CharCounterProps> = ({ value, limit, label }) => {
  const count = (value || "").length;
  const over = limit > 0 && count > limit;
  return (
    <small
      className={over ? "home-content-counter over" : "home-content-counter"}
      style={{ display: "block", marginTop: "0.25rem" }}
      aria-live="polite"
    >
      {label ? `${label}: ` : ""}
      {count}
      {limit > 0 ? ` / ${limit}` : ""} characters
      {over ? " — over the recommended length; consider tightening for readability." : ""}
    </small>
  );
};

export default CharCounter;
